import { useState } from 'react';
import { faqItems } from '@/mocks/homepage';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-secondary-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            快速解答您最关心的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((faq, i) => (
            <div
              key={i}
              className="rounded-lg bg-background-50 border border-secondary-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-secondary-50 transition-colors duration-200"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === i ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-foreground-400" />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}